export default "__VITE_ASSET__K5kjd6Pg__"